import { FormControl, InputLabel, MenuItem, FormHelperText, Select } from '@mui/material';
import { isMobile } from 'react-device-detect';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const MuiValidSelect = ({
  field,
  form: { touched, errors },
  variant,
  label,
  itemValues,
  itemLabels,
  sx,
  native = false,
  ...props
}) => {
  const hasError = touched[field.name] && errors[field.name] && true;

  return (
    <FormControl sx={{ width: '100%', ...sx }}>
      <InputLabel
        error={hasError}
        id="select-label"
        variant={variant}
        shrink
        style={{ pointerEvents: 'none' }}
      >
        {label}
      </InputLabel>
      <Select
        error={hasError}
        labelId="select-label"
        MenuProps={MenuProps}
        variant={variant}
        {...field}
        {...props}
        native={native || isMobile}
      >
        {native || isMobile
          ? [
              <option key="Default" value="" />,
              itemValues?.map((val, index) => (
                <option key={val + index} value={val}>
                  {itemLabels[index]}
                </option>
              )),
            ]
          : [
              itemValues?.map((val, index) => (
                <MenuItem key={val} value={val}>
                  {itemLabels[index]}
                </MenuItem>
              )),
            ]}
      </Select>
      <FormHelperText sx={{ ml: 0 }} error={hasError}>
        {hasError && errors[field.name]}
      </FormHelperText>
    </FormControl>
  );
};

export default MuiValidSelect;
